export class CancellablePromise<T> {
  public readonly promise: Promise<T>
  public readonly cancel: () => void

  constructor(promise: Promise<T>, cancelFn: () => void) {
    this.promise = promise
    this.cancel = cancelFn
  }
}
